import type { ReactNode } from "react";

type Props = {
  title: string;
  description?: string;
  titleInfo?: ReactNode;
  /**
   * Optional trailing action (e.g. a "Save changes" button). On wide enough
   * containers it sits to the right of the title; on narrow ones it stacks
   * below so neither the title nor the button is squeezed. Stacking is driven
   * by a container query, so the parent card must set `@container`.
   */
  action?: ReactNode;
};

export function SectionHeader({ title, description, titleInfo, action }: Props) {
  const heading = (
    <div className="flex flex-col gap-1">
      <div className="flex items-center gap-2">
        <h2 className="text-h4 text-black">{title}</h2>
        {titleInfo}
      </div>
      {description && <p className="text-small text-grey-900">{description}</p>}
    </div>
  );

  if (!action) return heading;

  return (
    <div className="flex flex-col gap-3 @md:flex-row @md:items-start @md:justify-between @md:gap-4">
      {heading}
      <div className="flex shrink-0 flex-wrap items-center gap-2">{action}</div>
    </div>
  );
}
